import React from 'react';
import Button from './Button';

const BottomPriceCard = () => (
  <div class="mt-6 px-4 md:px-64 bg-white">
    <div class="pb-4 pt-6 ">
      <h3
        class="inline-flex px-4 py-1 rounded-full text-xs md:text-sm leading-5 font-medium tracking-wide uppercase bg-yellow text-white"
        id="tier-standard"
      >
        Columbia Gas Customers
      </h3>
      <div class="mt-2 flex items-baseline text-4xl md:text-6xl leading-none font-extrabold">
        $0.899
        <span class="ml-1 text-lg md:text-2xl leading-8 font-medium text-gray-700">/CCF</span>
        <div class="w-20 md:w-48 ml-20 md:ml-24">
          <img src={require('../svg/Columbia-gas-logo.png')} alt="Columbia Logo"></img>
        </div>
      </div>
      <p class="mt-4 text-xs md:text-md leading-5 md:leading-7 text-gray-600">
        The introductory rate is for your FIRST MONTH of service. After that month is up, the
        customer will revert to our standard month-to-month variable rate. No cancellation fees or
        contracts.
      </p>
    </div>
  </div>
);

export default BottomPriceCard;
